import io from 'socket.io-client'
import { NvApiConfig } from '../Configs'
const config = __CONFIG__

const create = ({ url, token, isLegacy = false, extraHeaders = {}, ...options }) => {
  let ioConfig = {
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 99999,
    forceNew: false,
    ...options
  }

  if (isLegacy) {
    ioConfig['secure'] = true
    ioConfig['transportOptions'] = {
      ...options.transportOptions,
      polling: {
        extraHeaders: {
          [NvApiConfig.AUTH_HEADER]: NvApiConfig.getAuth(token),
          ...extraHeaders
        }
      }
    }
  } else {
    ioConfig['transports'] = ['websocket']
    ioConfig['query'] = { ...options.query, auth: token }
  }

  return io(url || `${config.IO_URL}`, ioConfig)
}

export default { create }
